import { useFeatureFlag } from '@moda/portal-stanchions';

export const useBiggerImagesOnPLP = () =>
  useFeatureFlag('bigger-images-on-plp', [{ default: false }, { if: true, then: true }]);
